var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteIconDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3274",
    "data-name": "Rectangle 3274",
    width: 16,
    height: 16,
    transform: "translate(16534 1108)",
    fill: "#8a8a8a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_164",
    "data-name": "Mask Group 164",
    transform: "translate(-16534 -1108)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "__TEMP__SVG__",
    transform: "translate(16531.332 1105.333)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2385",
    "data-name": "Path 2385",
    d: "M5.546,5.333l.983,12.113A1.22,1.22,0,0,0,7.75,18.667h5.875a1.22,1.22,0,0,0,1.221-1.221l.971-12.113ZM8.113,16.375,7.833,6.667H8.6l.287,9.708H8.113Zm2.929,0h-.75V6.667h.75Zm2.179,0h-.775l.283-9.708H13.5Z",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2386",
    "data-name": "Path 2386",
    d: "M15.167,3.833h-1.5l-1.1-.958a.845.845,0,0,0-.55-.209h-2.7a.857.857,0,0,0-.558.209l-1.1.958h-1.5c-.734,0-1.25.35-1.25,1.083h11.5c0-.734-.517-1.083-1.25-1.083Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIconDark);
export default __webpack_public_path__ + "static/media/deleteIconDark.76639ceb32901e40fe8c70056b36bdbe.svg";
export { ForwardRef as ReactComponent };